export default import.meta.ROLLUP_FILE_URL_g9wqDgpGXM5G9ONyZt4GbA